import React from 'react';
import styles from '../BotResponse.module.scss';
import Carousel from 'component/molecules/carousel/Carousel';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import VoiceTag from 'component/atom/voice-tag/VoiceTag';
import GenerateForm from './components/form/GenerateForms';
import TypingMessage from './components/typying-message/TypingMessage';
import { transformChatData } from 'component/organism/chat-console/factory/transformData';
import downloadUrlFile from 'helpers/downloadUrlFile';

function parseStreamedMessage(raw) {
  if (typeof raw !== 'string') {
    return { displayText: '', documents: [] };
  }

  const finalIndex = raw.indexOf('event: final');
  const visiblePart =
    finalIndex !== -1 ? raw.slice(0, finalIndex).trim() : raw.trim();
  const metaPart = finalIndex !== -1 ? raw.slice(finalIndex) : '';

  let documents = [];

  if (metaPart) {
    const dataMatch = metaPart.match(/data:\s*(\{[\s\S]*\})/);
    if (dataMatch && dataMatch[1]) {
      try {
        const parsed = JSON.parse(dataMatch[1]);
        const refs = Array.isArray(parsed.references) ? parsed.references : [];

        documents = refs
          .map((r) => {
            const baseName =
              r.shortDisplayReference ||
              r.fileName ||
              r.title ||
              r.unitTitle ||
              r.lessonTitle ||
              '';

            const name = baseName
              ? `${baseName} - صفحة ${r.page}`
              : `صفحة ${r.page}`;

            const url = r.url || null;

            return { id: r.id, name, url };
          })
          .filter((d) => !!d.name);
      } catch (e) {
        console.error('Failed to parse SSE data JSON', e);
      }
    }
  }

  return { displayText: visiblePart, documents };
}

const renderStepContent = ({
  step,
  sideBar_PrimaryColor,
  isWorkFlow,
  chatId,
  botId,
  setGuestChat,
  setCapture,
  setSuggestedQuestions,
  isExpanded,
  restartForm,
  guestChat,
  isConversation,
  triggerNewConversation,
  parentIsStreaming,
}) => {
  switch (step?.type) {
    case 'Message': {
      const { displayText, documents } = parseStreamedMessage(step.value);
      const safeText =
        typeof displayText === 'string'
          ? displayText
          : String(displayText || '');

      return (
        <div>
          <div
            className={styles['request-text']}
            dir='auto'
            style={{ unicodeBidi: 'isolate' }}
          >
            <TypingMessage
              text={safeText}
              isStreaming={parentIsStreaming}
              speed={38}
            />
          </div>

          {documents.length > 0 && (
            <div className={styles['doc-pills-container']}>
              {documents.map((doc) =>
                doc.url ? (
                  <a
                    key={doc.id}
                    href={doc.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    className={`${styles['doc-pill']} ${styles['doc-link']}`}
                  >
                    {doc.name}
                  </a>
                ) : (
                  <span key={doc.id} className={styles['doc-pill']}>
                    {doc.name}
                  </span>
                )
              )}
            </div>
          )}
        </div>
      );
    }

    case 'Image':
      return (
        <div className={styles['image-response']}>
          <img src={step.value} alt={step.value} />
        </div>
      );

    case 'Video':
      return (
        <div className={styles['video-response']}>
          <video controls>
            <source src={step.value} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </div>
      );

    case 'Carousel':
      return (
        <div className={styles['carousel-response']}>
          {step?.value?.details?.length > 0 ? (
            <Carousel data={step.value.details} />
          ) : null}
        </div>
      );

    case 'Document':
      return (
        <div className={styles['file-response']}>
          <SvgWithBranding
            type='download'
            className={`${styles.svg} ${styles['download-svg']}`}
            color={sideBar_PrimaryColor}
            onClick={() => downloadUrlFile(step.value, step.name)}
          />
          <p>{step.name ?? 'Document'}</p>
          <SvgWithBranding
            type='file'
            className={styles.svg}
            color={sideBar_PrimaryColor}
          />
        </div>
      );

    case 'Voice':
      return (
        <div className={styles['voice-response']}>
          <VoiceTag />
        </div>
      );

    case 'Form':
      return (
        <div className={styles['form-response']}>
          <GenerateForm
            step={step}
            isWorkFlow={isWorkFlow}
            chatId={chatId}
            botId={botId}
            onChatUpdate={(newChatData) => {
              setGuestChat((prev) => ({
                ...prev,
                ...newChatData,
                messages: [
                  ...prev.messages,
                  ...transformChatData(newChatData).messages,
                ],
              }));
            }}
            setSuggestedQuestions={setSuggestedQuestions}
            setCapture={setCapture}
            isExpanded={isExpanded}
            restartForm={restartForm}
            guestChat={guestChat}
            isConversation={isConversation}
            triggerNewConversation={triggerNewConversation}
          />
        </div>
      );

    default:
      return null;
  }
};

export default renderStepContent;
